import { useEffect } from 'react';
import { useThrottleFn } from 'ahooks';
import type { IEChartInstance } from '@/pages/intelligence/types/echart';

/**
 * 监听window的resize事件，处理echarts resize
 * chartInstance echart实例
 */
export default function useEChartResize(chartInstance: React.MutableRefObject<IEChartInstance | null>) {
  const handleResize = () => {
    if (typeof chartInstance?.current?.resize !== 'function') return;
    setTimeout(() => {
      chartInstance?.current?.resize();
    });
  };

  const { run: handleResizeRun, flush: handleResizeFlush } = useThrottleFn(handleResize, {
    wait: 300,
    leading: true,
    trailing: true,
  });

  useEffect(() => {
    window.addEventListener('resize', handleResizeRun, false);

    handleResizeRun();
    handleResizeFlush();

    return () => {
      window.removeEventListener('resize', handleResizeRun);
    };
  }, []);
}
